import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { ICartDefaultInfo, ICartListInfo} from "../interface/ICart";
import { GetCartsServiceParamModel } from "../model/cart";


import CartService from "../service/CartService";
import { RootState } from "../store/store";

import { logoutUser } from "./common";


const _service = new CartService();

export const resetCarts = createAction("carts/reset")

type SliceState = { value: ICartDefaultInfo, status: string,apiCallCount:number }

const initialState: SliceState = {
  value:  {},
  status: COMMON_STATUS.INITIAL,
  apiCallCount:0
} as SliceState;


export const getCartsAsync = createAsyncThunk(
  "carts/carts",
  async (params: GetCartsServiceParamModel) => {
    const response = await _service.getCartsService(params);
    return response;
  }
);

export const cartsSlice = createSlice({
  name: "carts",
  initialState,
  reducers:{
    updateCartsStatus: (state: SliceState, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //GET
      .addCase(getCartsAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getCartsAsync.fulfilled, (state, action) => {
        state.value = action.payload;
        state.status = COMMON_STATUS.LOADED;
        state.apiCallCount =0;

      })
      .addCase(getCartsAsync.rejected, (state) => {
        state.status = COMMON_STATUS.FAILED;
        state.apiCallCount +=1;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetCarts, () => {
        return initialState;
      });
  },
});
export const { updateCartsStatus} = cartsSlice.actions;

 export const getCarts = (state: RootState) => state.carts;
export const getCartsInfo = (state: RootState) => state.carts.value;
export const getCartsStatus = (state: RootState) => state.carts.status;

export default cartsSlice.reducer;